export default "__VITE_ASSET__BbcPZ_AK__"